var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","bottom":"0","left":"0","right":"0","width":"100%"}},[_c('v-btn',{staticClass:"button__100per",attrs:{"text":""},on:{"click":function($event){return _vm.$emit('click:apply')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }